/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const ChartLineIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <rect x="0.5" y="3.5" width="23" height="17" />
      <rect x="2.5" y="5.5" width="19" height="13" />
      <polyline points="4.5 15.5 7.5 10.5 10.5 15.5 13 12.5 15.5 15.5 19.5 8.5" />
    </g>
  </svg>
);

export default ChartLineIcon;
